export default __webpack_public_path__ + "static/media/breakeven_tag.035f8e42.svg";